import React from 'react'
import { VoiceAgentCallMain } from '../../components/VoiceAgentCallMain'
import { SkillsCollectionProvider } from './context/SkillsCollectionProvider'

export const SkillsCollection = () => {
  return (
    <SkillsCollectionProvider>
      <VoiceAgentCallMain />
    </SkillsCollectionProvider>
  )
}
